module.exports = __webpack_public_path__ + "media/packs/src/assets/images/google-icon-097c67a2ee1a999c6dad1f678e461fa9.svg";